import { ReactNode } from 'react';

import styles from './Center.module.scss';

interface Props {
  children: ReactNode;
}

export function Center(props: Props) {
  return <div className={styles['center']}>{props.children}</div>;
}
